import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const CodeWrapper = styled.div`
  width: 100%;
`;

const decodeHtmlEntities = (html) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html;
  return textarea.value;
};

const parseStyleString = (styleString) => {
  return styleString.split(";").reduce((styleObj, styleRule) => {
    if (styleRule.trim()) {
      const [property, value] = styleRule.split(":");
      if (property && value) {
        styleObj[
          property.trim().replace(/-./g, (match) => match[1].toUpperCase())
        ] = value.trim();
      }
    }
    return styleObj;
  }, {});
};

const Code = ({ code }) => {
  const [parsedNodes, setParsedNodes] = useState([]);

  useEffect(() => {
    const decodedCode = decodeHtmlEntities(code);
    const parser = new DOMParser();
    const parsedDoc = parser.parseFromString(decodedCode, "text/html");
    const bodyChildren = Array.from(parsedDoc.body.childNodes);

    setParsedNodes(bodyChildren);
  }, [code]);

  return (
    <CodeWrapper>
      {parsedNodes.map((node, index) => {
        switch (node.nodeType) {
          case Node.ELEMENT_NODE: {
            const attributes = Array.from(node.attributes).reduce(
              (attrs, attr) => {
                if (attr.name === "style") {
                  attrs.style = parseStyleString(attr.value);
                } else {
                  attrs[attr.name] = attr.value;
                }
                return attrs;
              },
              {}
            );

            return React.createElement(node.nodeName.toLowerCase(), {
              key: index,
              ...attributes,
            });
          }
          case Node.TEXT_NODE: {
            return (
              <React.Fragment key={index}>{node.textContent}</React.Fragment>
            );
          }
          default:
            return null;
        }
      })}
    </CodeWrapper>
  );
};

Code.propTypes = {
  code: PropTypes.string.isRequired,
};

export default Code;
